module.exports = __webpack_public_path__ + "img/logo_light.1aa5fc93.png";